<template>
  <div class="pt-3">
    <div>
      <div class="d-flex justify-content-between">
        <div><b>{{ transaction.redemptionDescription }}</b></div>
        <div><b>{{ -transaction.redeemedAmount > 0 ? '+' : '' }}{{ formatPrice(-transaction.redeemedAmount) }}</b></div>
      </div>
      <div class="d-flex justify-content-between">
        <div>{{ toMonthDayYearString(transaction.created) }}</div>
        <div
          class="text-pewter">
          Balance: {{ formatPrice(transaction.clientClosingBalance) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toMonthDayYearString, formatPrice } from '@/utils/stringParsing.js'

defineProps({
  transaction: { type: Object, required: true }
})

</script>
